/**
 * This is the starting point of your application.
 * Feature Hub Apps will use this file to bootstrap the app.
 */
import React from 'react';
import { useContent } from '@oneaudi/feature-app-utils';
import StageContainer from './components/stage-container/StageContainer';
import CaeGate from './components/CaeGate';
import type { FalconContent, StagePropsFACE } from '../types';

import { transformCmsDataToProps } from './utils/transformCmsDataToProps';
import ContentContextProvider from './ContentContext';
import { FascinationContextProvider } from './context/FascinationContextProvider';

const FeatureApp: React.FC = () => {
  const rawContent = useContent<StagePropsFACE | FalconContent>() || undefined;
  const content = transformCmsDataToProps(rawContent as StagePropsFACE | FalconContent);
  const isHeadless = rawContent?.__type === 'aem-headless';

  if (typeof content === 'undefined') {
    return <p>No content found for Stage Component</p>;
  }

  return (
    <CaeGate>
      <ContentContextProvider isHeadless={isHeadless} content={content}>
        <FascinationContextProvider>
          <StageContainer />
        </FascinationContextProvider>
      </ContentContextProvider>
    </CaeGate>
  );
};

export default FeatureApp;
